import { IconButton, styled } from '@mui/material';
import {
  closeSnackbar,
  MaterialDesignContent,
  SnackbarKey,
  SnackbarProvider as Provider,
} from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

const action = (snackbarId: SnackbarKey) => (
  <IconButton
    onClick={() => {
      closeSnackbar(snackbarId);
    }}
  >
    <CloseIcon sx={{ color: '#FFF' }} />
  </IconButton>
);

const StyledMaterialDesignContent = styled(MaterialDesignContent)(
  ({ theme }) => ({
    '&.notistack-MuiContent-warning': {
      backgroundColor: theme.palette.warning.main,
    },
    '&.notistack-MuiContent-error': {
      backgroundColor: theme.palette.error.main,
    },
    '&.notistack-MuiContent-success': {
      backgroundColor: theme.palette.primary.main,
    },
  })
);

interface SnackbarProviderProps {
  children: JSX.Element;
}

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  return (
    <Provider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      maxSnack={1}
      autoHideDuration={5000}
      action={action}
      Components={{
        warning: StyledMaterialDesignContent,
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
      }}
    >
      {children}
    </Provider>
  );
};
